import { render, staticRenderFns } from "./GenericRecordAddOrLinkPhotoDialog.vue?vue&type=template&id=225693de&scoped=true"
import script from "./GenericRecordAddOrLinkPhotoDialog.vue?vue&type=script&lang=js"
export * from "./GenericRecordAddOrLinkPhotoDialog.vue?vue&type=script&lang=js"
import style0 from "./GenericRecordAddOrLinkPhotoDialog.vue?vue&type=style&index=0&id=225693de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225693de",
  null
  
)

export default component.exports